module.exports = __webpack_public_path__ + "static/icon-fe439d9dce8858f8483f7abba7595a4b.png";